



















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import BaseModal from '@/components/ui/BaseModal.vue'
import FramePopup from './FramePopup.vue'
import ShoppingCartItem from './ShoppingCartItem.vue'
import CartItem, { ICartItem } from '@/store/models/CartItem'
import GlassOption from '@/data/glass-option'
import DefaultButton from '@/components/ui/DefaultButton.vue'
import { BasketType } from '@/data/enums'
import '@/icons/cart'

@Component({
  components: {
    ShoppingCartItem,
    BaseModal,
    DefaultButton,
    FramePopup
  },
  computed: {
    ...mapState('cart', [
      'items'
    ])
  }
})
export default class ShoppingCart extends Vue {
  public items!: ICartItem[]
  private showDeleteModal: boolean = false
  private showFrameModal: boolean = false
  private tempItem?: ICartItem
  private frameItem: CartItem | undefined

  private created () {
    this.frameItem = undefined
  }
  private get sortItems (): ICartItem[] {
    const sorted = this.items.sort((a, b) => (a.price < b.price) ? 1 : ((b.price < a.price) ? -1 : 0))
    return sorted
  }

  private get showPrice (): boolean {
    const type = this.$store.state.data.optician.basketType
    switch (type) {
      case BasketType.None:
        return false
      case BasketType.Total:
        return true
      case BasketType.Current:
        return true
      case BasketType.Amount:
        return true
    }
    return true
  }

  private modalDeleteItem (isDelete: boolean) {
    if (isDelete) {
      this.showDeleteModal = false
      if (this.tempItem) {
        const redirect = (this.$route.fullPath.indexOf('/glasses') !== -1)
          ? (this.tempItem.id === this.$store.state.cart.currentItem.id)
          : this.$store.state.cart.items.length < 2

        this.$store.dispatch('cart/removeItem', this.tempItem)
          .then(() => {
            if (redirect) {
              this.$router.push('/glasses')
                .catch((err) => console.error(err))
            }
          })
          .catch((err) => console.error(err))
      }
    } else {
      this.showDeleteModal = false
    }
    this.tempItem = undefined
  }

  private close () {
    this.showFrameModal = false
  }

  private removeItem (item: ICartItem) {
    this.tempItem = item
    this.showDeleteModal = true
  }

  private removeOption (option: GlassOption) {
    this.$store.dispatch('cart/removeOption', option)
      .catch((err) => console.error(err))
  }

  private frameOption (item: CartItem) {
    this.frameItem = item
    this.showFrameModal = true
  }
}
